import { render } from "./01_Hero.vue?vue&type=template&id=7d68809c&scoped=true"
import script from "./01_Hero.vue?vue&type=script&lang=js"
export * from "./01_Hero.vue?vue&type=script&lang=js"

import "./01_Hero.vue?vue&type=style&index=0&id=7d68809c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d68809c"]])

export default __exports__